import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import authSlice from "./slices/auth.slice";
import { baseApi, baseApiV2 } from "./slices/base-api.slice";
import editorSlice from "./slices/editor.slice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    editor: editorSlice,
    [baseApi.reducerPath]: baseApi.reducer,
    [baseApiV2.reducerPath]: baseApiV2.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, baseApiV2.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;
